export default __webpack_public_path__ + "static/media/toyhouse.542c43e3.svg";